import styles from './styles.module.css';

export const ProgressSteps = ({ step, count = 2 }) => {
  const steps = [...Array(count)].map((_, i) => i + 1);

  const getStepCountStyles = (s) => {
    if (s === step) {
      return styles.stepCountActive;
    }
    if (s < step) {
      return styles.stepCountDone;
    }
    return styles.stepCount;
  };

  const getStepLineStyles = (s) => {
    if (s === step) {
      return styles.stepLineActive;
    }
    if (s < step) {
      return styles.stepLineDone;
    }
    return styles.stepLine;
  };

  return (
    <div className={styles.stepContainer}>
      {steps.map((s) => (
        <div className={styles.step} key={s}>
          <div className={getStepCountStyles(s)}>{s}</div>
          <div className={getStepLineStyles(s)}></div>
        </div>
      ))}
    </div>
  );
};
